const getPreferenceCenterSmsPreferenceSection = require("./getPreferenceCenterSmsPreferenceSection");
const afterElement = require("../dom/afterElement");
const smsNotAvailableInYourCountry = require("./smsNotAvailableInYourCountry");
const getPreferenceCenterSmsNotAvailableInYourCountry = require("./getPreferenceCenterSmsNotAvailableInYourCountry");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function showPreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter) {
    const smsSection = getPreferenceCenterSmsPreferenceSection(preferenceCenter);

    let smsNotAvailableInYourCountry$ = getPreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter);

    if (!smsNotAvailableInYourCountry$) {
        smsNotAvailableInYourCountry$ = smsNotAvailableInYourCountry();

        afterElement(smsSection, smsNotAvailableInYourCountry$);
    }
}
